'use strict';

/*exported guid*/
function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }

  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

/*exported invokeCallback*/
function invokeCallback(callback, par1, par2, par3) {
  if (!callback) {
    return;
  }

  if (typeof par3 !== 'undefined') {
    return callback(par1, par2, par3);
  }

  if (typeof par2 !== 'undefined') {
    return callback(par1, par2);
  }

  if (typeof par1 !== 'undefined') {
    return callback(par1);
  }

  callback();
}

/*exported getCallStack */
function getCallStack() {

  /* jshint ignore:start */
  var stack = '';
  var callee = arguments.callee;
  while (!isEmpty(callee)) {
    stack += callee.name + '\r\n';

    callee = callee.caller;
  }

  return stack;
  /* jshint ignore:end */

}

/*exported isEmpty */
function isEmpty(obj) {
  if (typeof obj === 'undefined' || obj === null || obj === '') {
    return true;
  }

  if (typeof obj === 'number' && isNaN(obj)) {
    return true;
  }

  if (obj instanceof Date && isNaN(Number(obj))) {
    return true;
  }

  return false;
}

/*exported isEqual */
function isEqual(val1, val2) {
  if (val1.toLowerCase() === val2.toLowerCase()) {
    return true;
  }

  return false;
}

/*exported echo */
function echo(str, target) {
  if (isEmpty(target) || target === 'console') {
    console.log(str);
  } else if (target === 'body') {
    var pre = document.createElement('pre');
    pre.innertHtml = str;
    document.body.appendChild(pre);
  } else if (target === 'alert') {
    alert(str);
  }

}

/*exported elementInViewport */
function elementInViewport(el) {
  var top = el.offsetTop;
  var left = el.offsetLeft;
  var width = el.offsetWidth;
  var height = el.offsetHeight;

  while (el.offsetParent) {
    el = el.offsetParent;
    top += el.offsetTop;
    left += el.offsetLeft;
  }

  return (
    top < (window.pageYOffset + window.innerHeight) &&
    left < (window.pageXOffset + window.innerWidth) &&
    (top + height) > window.pageYOffset &&
    (left + width) > window.pageXOffset
  );
}

/*exported elementIsVisible */
function elementIsVisible($el, $wrapper) {
  //TODO: dle potreby upravit - nyni sleduje pouze spodni hranu
  var top = $el.position().top - $wrapper.scrollTop();

  return (
    top < $wrapper.outerHeight()
  );
}

/*exported confirmRemove */
/*globals confirm*/
function confirmRemove(msg) {
  return confirm(msg);
}

/*exported toAscii */
function toAscii(str) {
  var withDiac    = 'áäčďéěíĺľňóô öŕšťúů üýřžÁÄČĎÉĚÍĹĽŇÓÔ ÖŔŠŤÚŮ ÜÝŘŽ';
  var withoutDiac = 'aacdeeillnoo orstuu uyrzAACDEEILLNOO ORSTUU UYRZ';

  var newStr = '';
  for (var i = 0; i < str.length; i++) {
    if (withDiac.indexOf(str.charAt(i)) !== -1) {
      newStr += withoutDiac.charAt(withDiac.indexOf(str.charAt(i)));
    } else {
      newStr += str.charAt(i);
    }

  }

  return newStr;
}

/*exported unBlockElement*/
function unBlockElement(element) {
  element.removeClass('uiBlockerParent')
         .find('.blocker')
         .remove();
}

/*exported blockElement*/
function blockElement(element) {
  unBlockElement(element);
  element.addClass('uiBlockerParent')
         .append('<div class="blocker">')
         .find('.blocker')
         .append($('<div class="loader" />').append('<span class="bar"></span><span class="bar"></span><span class="bar"></span>'));
}

/*exported replaceAttrKey*/
function replaceAttrKey(elem, attr, nthAr, key) {
  var nameValue = elem.attr(attr);
  if (!isEmpty(nameValue)) {
    var nth = 0;
    nameValue = nameValue.replace(/\[([0-9]|[a-z]|[A-Z]|")*\]/g, function (match) {
      nth++;
      return (nth === (nthAr)) ? '[' + key + ']' : match;
    });

    elem.attr(attr, nameValue);
  }
}

/*exported getInputName*/
function getInputName($elem) {
  var name = $elem.attr('name');
  var index = name.lastIndexOf('[');
  name = name.substring(index + 1, name.length - 1);

  return name;
}

/*exported stringToDate*/
function stringToDate(date, format, delimiter) {
  var formatLowerCase = format.toLowerCase();
  var formatItems = formatLowerCase.split(delimiter);
  var dateItems = date.split(delimiter);

  var monthIndex = formatItems.indexOf('mm');
  var dayIndex = formatItems.indexOf('dd');
  var yearIndex = formatItems.indexOf('yyyy');

  var month = parseInt(dateItems[monthIndex]);
  month -= 1;

  var formatedDate = new Date(dateItems[yearIndex], month, dateItems[dayIndex]);
  return formatedDate;
}

/*exported compareTimes*/
function compareTimes(firstTime, secondTime) {
  if (Date.parse('01/01/2011 ' + firstTime) === Date.parse('01/01/2011 ' + secondTime)) {
    return 0;
  }

  return Date.parse('01/01/2011 ' + firstTime) > Date.parse('01/01/2011 ' + secondTime) ? -1 : 1;
}

/*exported compareDates*/
function compareDates(firstDate, secondDate) {
  if (!(firstDate instanceof Date)) {
    firstDate = stringToDate(firstDate, 'dd.mm.yyyy', '.');
  }

  if (!(secondDate instanceof Date)) {
    secondDate = stringToDate(secondDate, 'dd.mm.yyyy', '.');
  }

  if (firstDate.getTime() === secondDate.getTime()) {
    return 0;
  }

  return firstDate.getTime() > secondDate.getTime() ? -1 : 1;
}

/*exported hoursInTime*/
function hoursInTime(time) {
  var diffHrs = Math.floor((time % 86400000) / 3600000); // hours
  var diffMins = Math.round(((time % 86400000) % 3600000) / 60000); // minutes

  return diffHrs + (diffMins / 60);
}

/*exported hoursBetweenDates*/
function hoursBetweenDates(firstDate, secondDate) {
  var time = (secondDate - firstDate); // milliseconds between firstTime and secondTime
  return hoursInTime(time);
}

/*exported daysBetweenDates*/
function daysBetweenDates(firstDate, secondDate) {
  var hours = hoursBetweenDates(firstDate, secondDate);
  return Math.floor(hours / 24);
}

/*exported hoursBetweenTimes*/
function hoursBetweenTimes(firstTime, secondTime) {
  var firstDate = Date.parse('01/01/2011 ' + firstTime);
  var secondDate = Date.parse('01/01/2011 ' + secondTime);

  return hoursBetweenDates(firstDate, secondDate);
}

/*exported addZero*/
function addZero(i) {
  if (i < 10) {
    i = '0' + i;
  }

  return i;
}

/*exported diffDate*/
function diffDate(dateFrom, dateTo) {
  if (!(dateFrom instanceof Date)) {
    dateFrom = stringToDate(dateFrom, 'dd.mm.yyyy', '.');
  }

  if (!(dateTo instanceof Date)) {
    dateTo = stringToDate(dateTo, 'dd.mm.yyyy', '.');
  }

  var timeDiff = Math.abs(dateTo.getTime() - dateFrom.getTime());

  return Math.ceil(timeDiff / (1000 * 3600 * 24));
}

/*exported diffTime*/
function diffTime(timeStart, timeStop) {
  return (timeStop - timeStart); // milliseconds between timeStop and timeStart
}

/*exported formatedTime*/
function formatedTime(time, hideZeroHours) {
  hideZeroHours = hideZeroHours || false;

  var diffDays = Math.floor((time / 86400000)); //days
  time -= diffDays * 86400000;
  var diffHrs = Math.floor(time / 3600000); // hours
  time -= diffHrs * 3600000;
  var diffMins = Math.floor(time / 60000); // minutes
  time -= diffMins * 60000;
  var diffSecs = Math.floor(time / 1000); // seconds

  return (!hideZeroHours || diffHrs > 0 ? diffHrs.toString() + ':' : '') + addZero(diffMins.toString()) + ':' + addZero(diffSecs.toString());
}

/*exported formatedDiffTime*/
function formatedDiffTime(timeStart, timeStop) {
  return formatedTime(diffTime(timeStart, timeStop));
}

/*exported formatTime*/
function formatTime(time) {
  if (!(time instanceof Date)) {
    time = parseInt(time);
    time = new Date(time);
  }

  return addZero(time.getHours()) + ':' + addZero(time.getMinutes()) + ':' + addZero(time.getSeconds());
}

/*exported formatTimeHM*/
function formatTimeHM(time) {
  if (!(time instanceof Date)) {
    time = parseInt(time);
    time = new Date(time);
  }

  return addZero(time.getHours()) + ':' + addZero(time.getMinutes());
}

/*exported formatTimeDM*/
function formatTimeDM(time) {
  if (!(time instanceof Date)) {
    time = parseInt(time);
    time = new Date(time);
  }

  return addZero(time.getDate()) + '.' + addZero(time.getMonth() + 1) + '.';
}

/*exported formatDate*/
function formatDate(date) {
  if (!(date instanceof Date)) {
    date = stringToDate(date, 'dd.mm.yyyy', '.');
  }

  return addZero(date.getDate()) + '.' + addZero(date.getMonth() + 1) + '.' + date.getFullYear();
}

/*exported addDays*/
function addDays(date, days) {
  days = days || 1;
  if (!(date instanceof Date)) {
    date = stringToDate(date, 'dd.mm.yyyy', '.');
  }

  var value = date.valueOf();
  value += 86400000 * days;

  return new Date(value);
}

/*exported roundToDecimals*/
function roundToDecimals(number, decimals) {
  if (decimals !== 0) {
    decimals = decimals || 2;
  }

  var coef = Math.pow(10, decimals);

  return Math.round(number * coef) / coef;
}

/*exported removeLeadingZeros*/
function removeLeadingZeros(x, base) {
  base = base || 10;

  var parsed = parseInt(x, base);

  if (isNaN(parsed)) {
    return 0;
  }

  return parsed;
}

/*exported createObjectCallBack*/
function createObjectCallBack(object, func, customParams) {
  return function () {
    if (typeof customParams !== 'undefined') {
      object[func](customParams, arguments);
    } else {
      object[func](arguments);
    }
  };
}

/*exported reloadPage*/
function reloadPage() {
  location.reload();
}

/*exported removeDiak*/
function removeDiak(str) {
  var withDiak = 'áäčďéěíĺľňóô öŕšťúů üýřžÁÄČĎÉĚÍĹĽŇÓÔ ÖŔŠŤÚŮ ÜÝŘŽ';
  var withOutdiak = 'aacdeeillnoo orstuu uyrzAACDEEILLNOO ORSTUU UYRZ';

  var newStr = '';
  for (var i = 0; i < str.length; i++) {
    if (withDiak.indexOf(str.charAt(i)) !== -1) {
      newStr += withOutdiak.charAt(withDiak.indexOf(str.charAt(i)));
    } else {
      newStr += str.charAt(i);
    }
  }

  return newStr;
}

/*exported doFilter*/
function doFilter(wrapper, targetElem, text, lang, filterData, hiddenClass) {
  filterData = filterData || 'text';
  var hideRow = isEmpty(hiddenClass);

  if (isEmpty(text) && (isEmpty(lang) || lang === 0)) {
    wrapper.find('[data-filter_target="' + targetElem + '"]').each(function () {
      if (hideRow) {
        $(this).show();
      } else {
        $(this).removeClass(hiddenClass);
      }
    });
  } else {
    wrapper.find('[data-filter_target="' + targetElem + '"]').each(function () {
      if (hideRow) {
        $(this).hide();
      } else {
        $(this).addClass(hiddenClass);
      }
    });

    var filter = '[data-filter_target="' + targetElem + '"]';
    if (!isEmpty(text)) {
      filter += '[data-filter_' + filterData + '*="' + removeDiak(text.toLowerCase()) + '"]';
    }

    if (!isEmpty(lang) && lang !== 0) {
      filter += '[data-filter_lang="' + lang + '"]';
    }

    wrapper.find(filter).each(function () {
      if (hideRow) {
        $(this).show();
      } else {
        $(this).removeClass(hiddenClass);
      }
    });
  }
}

/*exported parseFloatK2*/
function parseFloatK2(str) {
  if (isEmpty(str)) {
    return 0;
  }

  if (typeof str === 'string') {
    str = str.replace(',', '.');
  }

  var float = parseFloat(str);
  if (isNaN(float)) {
    return 0;
  }

  return float;
}

/*exported formatFloatK2*/
function formatFloatK2(number) {
  return number.toString().replace('.', ',');
}

/*exported formatNumberK2 */
function formatNumberK2(number) {
  var parts = number.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  return parts.join(',');
}

/*exported compareNumbers*/
function compareNumbers(firstNumber, secondNumber) {
  if (isEmpty(firstNumber) && isEmpty(secondNumber)) {
    return 0;
  }

  if (isEmpty(firstNumber)) {
    return 1;
  }

  if (isEmpty(secondNumber)) {
    return -1;
  }

  firstNumber = parseFloatK2(firstNumber);
  secondNumber = parseFloatK2(secondNumber);

  if (firstNumber === secondNumber) {
    return 0;
  }

  return firstNumber > secondNumber ? -1 : 1;
}

/*exported nl2br*/
function nl2br(string) {
  string = string.replace(/(?:\r\n|\r|\n)/g, '<br>');

  return string;
}
